import VehicleMovementList from "pages/VehicleMovementPages/VehicleMovementList/VehicleMovementList"

const VehicleMovementsTab = ({ customer }) => {
  if (!customer?.id) {
    return <div className="text-muted">Customer not loaded.</div>
  }

  return <VehicleMovementList customerId={customer.id} customer={customer} />
}

export default VehicleMovementsTab
